jQuery(function ($) {

	//Convertir todos los elementos que tengan la clase ".data-link" en links
	$('.data-link').each( function(e) {
		$(this).on("click", function() {
			window.location.href = $(this).attr("data-link");
		});
	});


});
